import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";


import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";


import moment from "moment-timezone";
import { ClinicUpdate, FetchAddAppoientmentVisit, FetchVisitReason, GetactiveAuth, GetappointmentsbyPut, GetDeliveryMode, getDetailsAgencyDoctor, GetDoctorsRequest, Getmyclinicpatient, GetPaymentSources, GetResource, Getserviceaddress, GetServiceParactiseaddress, Postappointments } from "../../api/helper";
import { ShowToast } from "../../helpers/ToastService";
import { setUserDetails } from "../../redux/cookiesReducer";
import WeekView from "../AgencyFlow/AgencyScreens/AppointmetCalander/WeekView";
import MonthView from "../AgencyFlow/AgencyScreens/AppointmetCalander/MonthView";
import AgendaView from "../AgencyFlow/AgencyScreens/AppointmetCalander/AgendaView";
import CalendarComponent from "../AgencyFlow/AgencyScreens/AppointmetCalander/CalendarComponent";
import TimeSelect from "../AgencyFlow/AgencyScreens/AppointmetCalander/TimeSelect";
import { DropDownManuCustomMulti } from "./DropDownButton";


// getDetailsAgencyDoctor

const validationSchema = Yup.object().shape({
  patientId: Yup.string().required("Client is required"),
  dob: Yup.string(), // DOB is auto-filled, so not required
  doctorId: Yup.string().required("Provider is required"),
  deliveryMode: Yup.string().required("Appointment type is required"),
  date: Yup.string()
    .required("Date is required")
    .test("is-future-or-today", "Date cannot be in the past", (value) => {
      if (!value) return false;
      const selected = moment(value, "YYYY-MM-DD");
      const today = moment().startOf("day");
      return selected.isSameOrAfter(today);
    }),
  startTime: Yup.string().required("Start time is required"),
  visitReason: Yup.string().required("Visit reason is required"),
  appointmentResource: Yup.string().required("Resource is required"),
  duration: Yup.number()
    .typeError("Duration must be a number")
    .required("Duration is required")
    .min(1, "Minimum duration is 1 minute"),
  appointmentStatus: Yup.string().required("Status is required"),
  serviceLocationId: Yup.string().required("Service location is required"),
  paymentSource: Yup.string(),
  patientIntake: Yup.array()
    .min(1, "At least one patient intake document is required")
    .required("Patient intake is required"),

  providerTask: Yup.array()
    .min(1, "At least one provider task must be selected")
    .required("Provider task is required"),

  // Booleans are optional unless you want to enforce selection
  "email-confirm": Yup.boolean(),
  "sms-confirm": Yup.boolean(),
  "inapp-confirm": Yup.boolean(),

  "provider-email-confirm": Yup.boolean(),
  "provider-sms-confirm": Yup.boolean(),
  "provider-inapp-confirm": Yup.boolean(),

  repeats: Yup.boolean(),

  repeatDays: Yup.array().when("repeats", {
    is: true,
    then: () =>
      Yup.array()
        .min(1, "Select at least one repeat day")
        .required("Repeat days required"),
    otherwise: () => Yup.array().notRequired(),
  }),

  endCondition: Yup.string().notRequired(),

  specificDate: Yup.string().when("endCondition", {
    is: "specific-date",
    then: () =>
      Yup.string()
        .required("Specific date is required")
        .test("valid-date", "Date is invalid", (value) => !!Date.parse(value)),
    otherwise: () => Yup.string().notRequired(),
  }),

  numberOfEvents: Yup.string().when("endCondition", {
    is: "number-of-events",
    then: () =>
      Yup.number()
        .typeError("Must be a number")
        .positive("Must be a positive number")
        .required("Number of events is required"),

    otherwise: () => Yup.mixed().notRequired(),
  }),
});

const ProviderCalendarView = () => {
  const dispatch = useDispatch();
  const [selectedSlot, setSelectedSlot] = useState(null);

  const [appointments, setAppointments] = useState([]);
  const [currentView, setCurrentView] = useState("week");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showAppointmentPanel, setShowAppointmentPanel] = useState(false);
  const [editingAppointmentId, setEditingAppointmentId] = useState(null);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showSyncModal, setShowSyncModal] = useState(false);
  const [currentAgendaTab, setCurrentAgendaTab] = useState("Scheduled");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState("");
  const [selectedResource, setSelectedResource] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [calendar, setCalendar] = useState([]);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  // console.log(profiledata,'===>profiledata')
  // getProfile

  const [clientdata, setclientdata] = useState([]);
  // console.log(clientdata,'====>clientdata')
  const [providerdata, setproviderdata] = useState([]);
  // console.log(providerdata,'===>providerdata')

  const [visitReasondata, setvisitReasondata] = useState([]);
  const [addressData, setaddressData] = useState([]);
  const [authorization, setauthorization] = useState(null);
  const [visitstatus, setvisitstatus] = useState([]);
  const [miniSelectedDate, setMiniSelectedDate] = useState(null);
  const [appointmentType, setappointmentType] = useState([]);
  const [clientEmail, setClientEmail] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [isEditingClientEmail, setIsEditingClientEmail] = useState(false);
  const [isEditingClientPhone, setIsEditingClientPhone] = useState(false);
  const [providerEmail, setProviderEmail] = useState("");
  const [providerPhone, setProviderPhone] = useState("");
  const [isEditingProviderEmail, setIsEditingProviderEmail] = useState(false);
  const [isEditingProviderPhone, setIsEditingProviderPhone] = useState(false);
  const [clientEmailError, setClientEmailError] = useState("");
  const [clientPhoneError, setClientPhoneError] = useState("");
  const [providerEmailError, setProviderEmailError] = useState("");
  const [providerPhoneError, setProviderPhoneError] = useState("");
  const [resourcedata, setresourcedata] = useState([]);
  const [selectedAppointmentType, setSelectedAppointmentType] = useState("");
  const [paymentmethoddata, setpaymentmethoddata] = useState([]);
  const [selectedpayment, setselectedpayment] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [providertimezone, setprovidertimezone] = useState("");
  const [clienttimezone, setclienttimezone] = useState("");
  const [servicelocation, setservicelocation] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [activeAppointment, setActiveAppointment] = useState(null);
  const [provideravailbledays, setprovideravailbledays] = useState([]);
  const [preDef, setPreDef] = useState({ ...profiledata });

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validatePhone = (phone) => {
    const regex = /^\d{10}$/;
    return regex.test(phone);
  };


  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
    watch,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      patientId: "",
      dob: "",
      doctorId: "",
      deliveryMode: "",
      date: "",
      startTime: "",
      visitReason: "",
      Duration: "",
      status: "",
      repeatAppointment: "",
      repeats: false,
      serviceLocationId: "",
      paymentSource: "",
      patientIntake: [],
      providerTask: [],
      appointmentResource: "",
      patientConfirmation: {
        emailConfirmation: false,
        phone: clientPhone,
        email: clientEmail,
        SMSConfirmation: false,
        pushNotification: false,
      },
      providerConfirmation: {
        phone: providerPhone,
        email: providerEmail,
        emailConfirmation: false,
        SMSConfirmation: false,
        pushNotification: false,
      },
    },
  });

  const repeats = watch("repeats");
  const selectedType = watch("deliveryMode");

  const [weeklySchedule, setWeeklySchedule] = useState({
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: [],
  });

  useEffect(() => {
    generateMiniCalendar(currentMonth.getFullYear(), currentMonth.getMonth());
  }, [currentMonth]);

  const generateMiniCalendar = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();

    let days = [];

    for (let i = 0; i < firstDay; i++) {
      days.push(null);
    }

    for (let d = 1; d <= lastDate; d++) {
      days.push(d);
    }

    setCalendar(days);
  };

  const handleDateClick = (year, month, day) => {
    const clickedDate = new Date(year, month, day);
    clickedDate.setHours(0, 0, 0, 0);

    if (!selectedDate || (selectedDate && selectedEndDate)) {
      setSelectedDate(clickedDate);
      setSelectedEndDate(null);
    } else if (
      selectedDate &&
      !selectedEndDate &&
      clickedDate >= selectedDate
    ) {
      setSelectedEndDate(clickedDate);
    } else {
      setSelectedDate(clickedDate);
      setSelectedEndDate(null);
    }
  };
  const goToPreviousMonth = () => {
    const newMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() - 1,
      1
    );
    setCurrentMonth(newMonth);
  };

  const goToNextMonth = () => {
    const newMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      1
    );
    setCurrentMonth(newMonth);
  };
  const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  };

  const filteredAppointments = appointments.filter((app) => {
    if (!selectedDate) return false;

    const appDate = new Date(app.date);
    const start = new Date(selectedDate);
    const end = selectedEndDate ? new Date(selectedEndDate) : null;

    if (!end) {
      const appointmentDateStr = appDate.toISOString().split("T")[0];
      const selectedDateStr = start.toISOString().split("T")[0];
      if (appointmentDateStr !== selectedDateStr) return false;
    }

    if (end) {
      appDate.setHours(0, 0, 0, 0);
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);

      if (appDate < start || appDate > end) return false;
    }

    if (selectedProvider && app.doctorRequestId?._id !== selectedProvider)
      return false;
    if (selectedResource && app.appointmentResource !== selectedResource)
      return false;
    if (selectedLocation && app.serviceLocationId?._id !== selectedLocation)
      return false;
    if (selectedReason && app.visitReason?._id !== selectedReason) return false;
    if (selectedStatus && app.appointmentStatus?._id !== selectedStatus)
      return false;
    if (
      selectedAppointmentType &&
      app?.deliveryMode?._id !== selectedAppointmentType
    )
      return false;
    if (selectedpayment && app?.paymentSource !== selectedpayment) return false;

    return true;
  });

  const handleViewChange = (view) => {
    setCurrentView(view);
  };
  const handleDateChange = (direction) => {
    const newDate = new Date(currentDate);

    if (direction === "prev") {
      if (currentView === "day") {
        newDate.setDate(newDate.getDate() - 1);
      } else if (currentView === "week") {
        newDate.setDate(newDate.getDate() - 7);
      } else if (currentView === "month") {
        newDate.setMonth(newDate.getMonth() - 1);
      }
    } else if (direction === "next") {
      if (currentView === "day") {
        newDate.setDate(newDate.getDate() + 1);
      } else if (currentView === "week") {
        newDate.setDate(newDate.getDate() + 7);
      } else if (currentView === "month") {
        newDate.setMonth(newDate.getMonth() + 1);
      }
    } else if (direction === "today") {
      newDate.setTime(new Date().getTime());
    }

    setCurrentDate(newDate);
  };

  const isProviderAvailable = (provider, date, startTime, duration) => {
    if (
      !provider ||
      !provider?.availableDays ||
      !Array.isArray(provider?.availableDays?.availableDays)
    ) {
      return false;
    }

    const selectedDay = moment(date).format("dddd");
    const selectedStart = moment(`${date}T${startTime}`);
    const selectedEnd = moment(selectedStart).add(duration, "minutes");

    const dayAvailability = provider?.availableDays?.availableDays?.find(
      (day) => day.day === selectedDay
    );

    if (!dayAvailability) {
      return false;
    }

    const isAvailable = dayAvailability?.shifts?.some((shift) => {
      const shiftStart = moment(`${date}T${shift.startTime}`);
      const shiftEnd = moment(`${date}T${shift.endTime}`);
      return (
        selectedStart.isSameOrAfter(shiftStart) &&
        selectedEnd.isSameOrBefore(shiftEnd)
      );
    });

    return isAvailable;
  };

  const onSubmit = async (formData) => {
    const provider = providerdata.find((p) => p._id === formData.doctorId);
    // const date = formData.date;
    // const startTime = formData.startTime;
    // const duration = parseInt(formData.duration || 0);
    // if (!isProviderAvailable(provider, date, startTime, duration)) {
    //   ShowToast("Provider is not available at the selected time and date.");
    //   return;
    // }

    const client = clientdata.find((c) => c._id === formData.patientId);

    const location = addressData.find(
      (loc) => loc._id === formData.serviceLocationId
    );
    const appointmentTypeItem = appointmentType.find(
      (type) => type._id === formData.deliveryMode
    );
    const reason = visitReasondata.find((r) => r._id === formData.visitReason);
    const repeatData =
      formData.repeats === true
        ? {
          repeatAppointment: "Yes",
          repeatDays: formData.repeatDays || [],
          endCondition: formData.endCondition,
          ...(formData.endCondition === "specific-date" && {
            specificDate: formData.specificDate,
          }),
          ...(formData.endCondition === "number-of-events" && {
            numberOfEvents: formData.numberOfEvents,
          }),
        }
        : {
          repeatAppointment: "No",
        };
    const data = {
      ...(authorization?.Auth && { authorizationDetailId: authorization._id }),
      patientRequestId: formData.patientId,
      dob: formData.dob,
      doctorRequestId: formData.doctorId,
      // agencyId: profiledata?._id,
      doctorId: provider.doctorId._id,
      patientId: client.patientId._id,
      deliveryMode: formData.deliveryMode,
      date: new Date(formData.date).toISOString(),
      startTime: formData.startTime,
      visitReason: formData.visitReason,
      appointmentResource: formData.appointmentResource,
      Duration: formData.duration ? `${formData.duration} minutes` : null,
      appointmentStatus: formData.appointmentStatus,
      serviceLocationId: formData.serviceLocationId,
      paymentSource: formData.paymentSource,
      patientIntake: formData.patientIntake || [],
      providerTask: formData.providerTask || [],
      patientConfirmation: {
        emailConfirmation: formData["email-confirm"] || false,
        SMSConfirmation: formData["sms-confirm"] || false,
        pushNotification: formData["inapp-confirm"] || false,
        phone: clientPhone,
        email: clientEmail,
      },
      providerConfirmation: {
        phone: providerPhone,
        email: providerEmail,
        emailConfirmation: formData["provider-email-confirm"] || false,
        SMSConfirmation: formData["provider-sms-confirm"] || false,
        pushNotification: formData["provider-inapp-confirm"] || false,
      },
      emailData: {
        clientName: client ? `${client.firstName} ${client.lastName}` : "",
        providerName: provider
          ? `${provider.firstName} ${provider.lastName}`
          : "",
        appointmentDate: moment(formData.date).format("DD-MM-YYYY HH:mm:ss"),
        appointmentTime: formData.startTime,
        timeZone: providertimezone,
        location: location?.name || "",
        appointmentType: appointmentTypeItem?.name || "",
        visitReason: reason?.visitReason || "",
        paymentSource: formData.paymentSource || "",
        logoUrl: "https://your-domain.com/logo.png",
        telehealthLink: "https://your-telehealth-link.com",
        documentLink: "https://your-document-link.com",
        manageAppointmentLink: "https://your-manage-link.com",
        supportEmail: "support@ennhealth.com",
      },
      ...repeatData,
    };
    console.log(data, "payload==-=-=-=-=-")
    return
    try {
      const response = await Postappointments(data);
      ShowToast(response.data.message, "success");
      setShowAppointmentPanel(false);
      reset();
      setValue("providerTask", []);
      setValue("patientIntake", []);
      FetchAppointment();
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  const Handleselecttask = (selectedOptions) => {
    let ids = selectedOptions.map((e) => e?._id);
    setValue("providerTask", ids, { shouldValidate: true });
  };
  const HandleselectpatientIntake = (selectedOptions) => {
    let ids = selectedOptions.map((e) => e?._id);
    setValue("patientIntake", ids, { shouldValidate: true });
  };

  const addTimeBlock = (day) => {
    const newBlock = { start: "08:00", end: "17:00", location: "Main Office" };
    setWeeklySchedule((prevState) => ({
      ...prevState,
      [day]: [...prevState[day], newBlock],
    }));
  };

  const removeTimeBlock = (day, index) => {
    setWeeklySchedule((prevState) => {
      const newDaySchedule = prevState[day].filter((_, i) => i !== index);
      return {
        ...prevState,
        [day]: newDaySchedule,
      };
    });
  };

  const handleSaveSettings = async () => {
    const respionse = await ClinicUpdate(preDef);
    dispatch(setUserDetails(respionse.data.data));
    ShowToast(respionse.data.message, "success");
    setPreDef({ ...respionse.data.data });
    setShowSettingsModal(false);
  };

  const handleTimeBlockChange = (day, index, field, value) => {
    const newSchedule = [...weeklySchedule[day]];
    newSchedule[index][field] = value;
    setWeeklySchedule((prevState) => ({
      ...prevState,
      [day]: newSchedule,
    }));
  };
  const hours = [];
  for (let i = 0; i < 24; i++) {
    if (i === 0) {
      hours.push("12 AM");
    } else if (i === 12) {
      hours.push("12 PM");
    } else if (i < 12) {
      hours.push(`${i} AM`);
    } else {
      hours.push(`${i - 12} PM`);
    }
  }

  // Generate calendar days for month view
  const generateCalendarDays = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay?.getDate();
    const startingDayOfWeek = firstDay?.getDay();

    const days = [];

    // Add previous month's days
    const prevMonthLastDay = new Date(year, month, 0).getDate();
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      days.push({
        day: prevMonthLastDay - i,
        isCurrentMonth: false,
        isPrevMonth: true,
      });
    }

    // Add current month's days
    for (let day = 1; day <= daysInMonth; day++) {
      days.push({
        day: day,
        isCurrentMonth: true,
        isPrevMonth: false,
      });
    }

    // Add next month's days to fill the grid (total 42 cells = 6 rows × 7 days)
    const totalCells = 42;
    let nextMonthDay = 1;
    while (days.length < totalCells) {
      days.push({
        day: nextMonthDay++,
        isCurrentMonth: false,
        isPrevMonth: false,
      });
    }

    return days;
  };

  const calendarDays = generateCalendarDays();

  const FetchServiceLocation = async (id) => {
    try {
      const response = await GetServiceParactiseaddress(profiledata?.agencyIds[0]);
      setservicelocation(
        Array.isArray(response?.data?.data?.data)
          ? response?.data?.data?.data
          : []
      );
      // setservicelocation(response);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchPaymentlist = async () => {
    try {
      const response = await GetPaymentSources(`?id=${profiledata?.agencyIds[0]}`);
      setpaymentmethoddata(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchResource = async () => {
    try {
      const respo = await GetResource(profiledata?.agencyIds[0]);
      setresourcedata(respo?.data?.data?.results);
    } catch (error) {
      console.log(error);
    }
  };
  // console.log(profiledata,"profiledata=======")
  const GetClients = async (page) => {
    console.log("hit-----Select-Client:------")
    try {
      let data = {
        limit: 100,
        page: 1,
        doctorId: profiledata?._id,
        status: "approved",
      };
      console.log(data, "payload=====")
      const response = await Getmyclinicpatient(data);
      console.log(response?.data.data, "response?.data.data=======")
      setclientdata(response?.data.data?.response);
    } catch (error) {
      console.log(error, "error=====");
    }
  };
  const FetchDoctorrequest = async () => {
    try {
      const response = await GetDoctorsRequest({ status: "approved", id: profiledata?.agencyIds[0] });
      setproviderdata(response?.data.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const GetVisitReason = async () => {
    const response = await FetchVisitReason(`?id=${profiledata?.agencyIds[0]}`);
    setvisitReasondata(response?.data?.data);
  };
  const GetAppoientmentVisit = async () => {
    const response = await FetchAddAppoientmentVisit(`?id=${profiledata?.agencyIds[0]}`);
    setvisitstatus(response?.data?.data);
  };
  const FetchDatalist = async () => {
    console.log("appointmentType==hit====")
    try {
      const response = await GetDeliveryMode(`?id=${profiledata?.agencyIds[0]}`);
      setappointmentType(response?.data?.data || []);
      console.log(response?.data?.data, "response?.data?.data ======appointmentType=")
    } catch (error) {
      console.log(error);
    }
  };
  const FetchAddresslist = async () => {
    const data = {
      id: profiledata?.agencyIds[0],
    };
    try {
      const response = await Getserviceaddress(data);
      setaddressData(response?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchAppointment = async () => {
    const data = {
      agencyId: profiledata?.agencyIds[0],
      page: 1,
      limit: 1000,
    };
    try {
      const respo = await GetappointmentsbyPut(data);
      setAppointments(respo?.data?.data?.appointments);
    } catch (error) {
      console.log(error, "error---");
    }
  };
  const PatientId = watch("patientId");
  const fetchAuthorizations = async () => {
    try {
      const activeauth = await GetactiveAuth(profiledata?.agencyIds[0], PatientId);
      setauthorization(activeauth?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (PatientId) {
      fetchAuthorizations();
    }
  }, [PatientId]);
  useEffect(() => {
    FetchDoctorrequest();
    FetchServiceLocation();
    FetchAddresslist();
    GetClients();
    GetVisitReason();
    GetAppoientmentVisit();
    FetchAppointment();
    FetchDatalist();
    FetchResource();
    FetchPaymentlist();
  }, []);
  const selectedClientId = watch("patientId");
  const formatDOB = (dobString) => {
    if (!dobString) return "";
    const date = new Date(dobString);
    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    const client = clientdata.find((c) => c._id === selectedClientId);
    if (client) {
      setValue("dob", formatDOB(client?.DOB));
      setValue("paymentSource", client?.PaymentSourcesId?.name);
      setClientEmail(client?.email || "");
      setClientPhone(client?.phone || "");
      setclienttimezone(client?.TimeZone || "");
    }
  }, [selectedClientId]);

  // useEffect(() => {
  //   const provider = providerdata.find((p) => p._id === watch("doctorId"));
  //   console.log(provider?.availableDays, "provider.availableDays=-=-=-=");
  //   if (provider) {
  //     setProviderEmail(provider?.email || "");
  //     setProviderPhone(provider?.phone || "");
  //     setprovidertimezone(provider?.TimeZone || "");
  //     setprovideravailbledays(provider.availableDays?.availableDays || []);
  //   }
  // }, [watch("doctorId")]);
  const selectedVisitReasonId = watch("visitReason");
  useEffect(() => {
    if (selectedVisitReasonId) {
      const selected = visitReasondata.find(
        (item) => item._id === selectedVisitReasonId
      );
      if (selected) {
        setValue("duration", selected.appointmentDuration);
        //  setValue("paymentSource", selected.PaymentSourcesId?.name);
      }
    }
  }, [selectedVisitReasonId, visitReasondata, setValue]);

  const startTime = watch("startTime");
  const selectedappointmentDate = watch("date");

  const cleanTimezone = (zone) => {
    if (!zone) return "";
    return zone.replace(/\s*\(GMT.*\)/, "");
  };

  const formatTimeInZone = (dateStr, timeStr, fromZone, toZone) => {
    if (!dateStr || !timeStr || !fromZone || !toZone) return "";

    const cleanFrom = cleanTimezone(fromZone);
    const cleanTo = cleanTimezone(toZone);

    const datetime = moment.tz(
      `${dateStr} ${timeStr}`,
      "YYYY-MM-DD HH:mm",
      cleanFrom
    );
    const converted = datetime.clone().tz(cleanTo);

    return converted.format("hh:mm A z");
  };
  const getAbbreviation = (dateStr, timeStr, zone) => {
    const cleanZone = cleanTimezone(zone);
    const dateTime = moment.tz(
      `${dateStr} ${timeStr || "12:00"}`,
      "YYYY-MM-DD HH:mm",
      cleanZone
    );
    return dateTime.format("z");
  };
  const providerAbbr = getAbbreviation(
    selectedappointmentDate,
    startTime,
    providertimezone
  );
  const clientAbbr = getAbbreviation(
    selectedappointmentDate,
    startTime,
    clienttimezone
  );

  const providerTime = formatTimeInZone(
    selectedappointmentDate,
    startTime,
    providertimezone,
    providertimezone
  );

  const clientTime = formatTimeInZone(
    selectedappointmentDate,
    startTime,
    providertimezone,
    clienttimezone
  );

  const [timeInterval, setTimeInterval] = useState(60);

  const generateTimeSlots = (intervalMinutes) => {
    const slots = [];
    const totalMinutes = 24 * 60;

    for (let i = 0; i < totalMinutes; i += intervalMinutes) {
      const hours = Math.floor(i / 60);
      const minutes = i % 60;

      let displayHour = hours % 12 || 12;
      let period = hours < 12 ? "AM" : "PM";
      const timeString = `${displayHour}:${minutes
        .toString()
        .padStart(2, "0")} ${period}`;

      slots.push({ value: i, display: timeString });
    }

    return slots;
  };

  const timeSlots = generateTimeSlots(timeInterval);
  const rowHeight = 60;

  const getAvailableDetails = async (id) => {
    const response = await getDetailsAgencyDoctor(id);
    const provider = response.data.data || [];
    setProviderEmail(provider?.email || "");
    setProviderPhone(provider?.phone || "");
    setprovidertimezone(provider?.TimeZone || "");
    setprovideravailbledays(provider.availableDays?.availableDays || []);
  };
  useEffect(() => {
    if (selectedSlot) {
      const isoDate = new Date(selectedSlot.date).toISOString().split("T")[0];
      setValue("date", isoDate);

      const hour = String(selectedSlot.slot.hour).padStart(2, "0");
      const minute = String(selectedSlot.slot.minute).padStart(2, "0");
      const timeValue = `${hour}:${minute}`;

      setValue("startTime", timeValue);
    }
  }, [selectedSlot, setValue]);

  return (
    <>
      <div className="container_CalendarView">
        <div className="header-bar_CalendarView">
          <div className="header-left_CalendarView">
            <div className="view-toggle_CalendarView">
              <button
                onClick={() => handleViewChange("week")}
                style={{ marginRight: 5 }}
                className="nav-button_CalendarView"
              >
                Week
              </button>
              <button
                onClick={() => handleViewChange("day")}
                style={{ marginRight: 5 }}
                className="nav-button_CalendarView"
              >
                Day
              </button>
              <button
                onClick={() => handleViewChange("month")}
                style={{ marginRight: 5 }}
                className="nav-button_CalendarView"
              >
                Month
              </button>
              <button
                onClick={() => handleViewChange("agenda")}
                className="nav-button_CalendarView"
              >
                Agenda
              </button>
            </div>
            <button
              onClick={() => handleDateChange("prev")}
              className="nav-button_CalendarView"
            >
              Prev
            </button>
            <button
              onClick={() => handleDateChange("today")}
              className="today-button_CalendarView"
            >
              Today
            </button>
            <button
              onClick={() => handleDateChange("next")}
              className="nav-button_CalendarView"
            >
              Next
            </button>

            <div className="date-range_CalendarView" id="date-range">
              {currentDate.toDateString()}
            </div>
          </div>
          <div>
            <button
              onClick={() => setShowAppointmentPanel(true)}
              className="add-new-button_CalendarView"
            >
              + Create Appointment
            </button>
            <button
              onClick={() => setShowSyncModal(true)}
              className="synch-button_CalendarView"
              style={{ marginLeft: 5, marginRight: 5 }}
            >
              Calendar Synch
            </button>
            <button
              onClick={() => setShowSettingsModal(true)}
              className="settings-button_CalendarView"
            >
              Settings
            </button>
          </div>
        </div>

        <div id="search-container">
          <input
            type="text"
            id="search-input"
            placeholder="Search appointments..."
          />
        </div>

        <div style={{ display: "flex", gap: 20 }}>
          <div className="mini-calendar-container_CalendarView">
            <div className="mini-calendar-container">
              <div className="calendar-header_two">
                <button className="nav-button" onClick={goToPreviousMonth}>
                  &lt;
                </button>
                <span className="month-label">
                  {currentMonth.toLocaleString("default", {
                    month: "long",
                    year: "numeric",
                  })}
                </span>
                <button className="nav-button" onClick={goToNextMonth}>
                  &gt;
                </button>
              </div>

              <table className="calendar-table">
                <thead>
                  <tr>
                    {["S", "M", "T", "W", "T", "F", "S"].map((day) => (
                      <th key={day}>{day}</th>
                    ))}
                  </tr>


                </thead>
                <tbody>
                  {Array.from({ length: Math.ceil(calendar.length / 7) }).map(
                    (_, weekIndex) => (
                      <tr key={weekIndex}>
                        {calendar
                          .slice(weekIndex * 7, weekIndex * 7 + 7)
                          .map((day, idx) => {
                            const fullDate =
                              day &&
                              new Date(
                                currentMonth.getFullYear(),
                                currentMonth.getMonth(),
                                day
                              );
                            const isToday =
                              fullDate && isSameDate(fullDate, new Date());
                            const isStart =
                              fullDate &&
                              selectedDate &&
                              isSameDate(fullDate, selectedDate);
                            const isEnd =
                              fullDate &&
                              selectedEndDate &&
                              isSameDate(fullDate, selectedEndDate);

                            return (
                              <td
                                key={idx}
                                className={`day-cell
                        ${isToday ? "today_date" : ""}
                        ${isStart ? "selected-start" : ""}
                        ${isEnd ? "selected-end" : ""}
                      `}
                                onClick={() =>
                                  day &&
                                  handleDateClick(
                                    currentMonth.getFullYear(),
                                    currentMonth.getMonth(),
                                    day
                                  )
                                }
                              >
                                {day || ""}
                              </td>
                            );
                          })}
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
            <div className="calendar-filters_CalendarView">
              {/* <div className="form-group_CalendarView">
                <label>Provider:</label>
                <select
                  value={selectedProvider}
                  onChange={(e) => setSelectedProvider(e.target.value)}
                >
                  <option value="">-- Select Provider --</option>
                  {providerdata.map((provider, index) => (
                    <option key={provider._id} value={provider._id}>
                      {provider.firstName} {provider.lastName}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="form-group_CalendarView">
                <label>Resource:</label>
                <select
                  value={selectedResource}
                  onChange={(e) => setSelectedResource(e.target.value)}
                >
                  <option value="">-- Select Resource --</option>
                  {resourcedata.map((item) => {
                    return (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group_CalendarView">
                <label>Location:</label>
                <select
                  value={selectedLocation}
                  onChange={(e) => setSelectedLocation(e.target.value)}
                >
                  <option value="">-- Select Location --</option>
                  {addressData.map((item) => {
                    return (
                      <option key={item._id} value={item?._id}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group_CalendarView">
                <label>Reason:</label>
                <select
                  value={selectedReason}
                  onChange={(e) => setSelectedReason(e.target.value)}
                >
                  <option value="">-- Select Reason --</option>
                  {visitReasondata.map((item) => {
                    return (
                      <option key={item._id} value={item._id}>
                        {item.visitReason}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group_CalendarView">
                <label>Status:</label>
                <select
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="">-- Select Status --</option>
                  {visitstatus.map((item) => {
                    return (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group_CalendarView">
                <label>Appointment Type:</label>
                <select
                  value={selectedAppointmentType}
                  onChange={(e) => setSelectedAppointmentType(e.target.value)}
                >
                  <option value="">-- Select type--</option>
                  {appointmentType.map((item, index) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group_CalendarView">
                <label>Payment Method:</label>
                <select
                  value={selectedpayment}
                  onChange={(e) => setselectedpayment(e.target.value)}
                >
                  <option value="">-- Select type--</option>
                  {paymentmethoddata.map((item, index) => (
                    <option key={item._id} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div id="selectedMiniDay">
              {selectedDate
                ? `Selected Date: ${selectedDate.toLocaleDateString("en-GB")}`
                : "No Date Selected"}
            </div>

            <ul id="miniEventList">
              {selectedDate && filteredAppointments.length > 0 ? (
                filteredAppointments.map((app, index) => (
                  <li
                    key={index}
                    onClick={() => alert(`Edit Appointment ${app._id}`)}
                  >
                    {app.startTime} - {app.Duration} |{" "}
                    {app.patientRequestId?.firstName} |{" "}
                    {app.doctorRequestId?.firstName}
                  </li>
                ))
              ) : (
                <li>No appointments for this date.</li>
              )}
            </ul>
          </div>

          <div style={{ flex: 1 }}>
            <div id="calendar-container" />

            {currentView === "week" && (
              <WeekView
                currentDate={currentDate}
                setCurrentDate={setCurrentDate}
                appointments={appointments}
                setSelectedSlot={setSelectedSlot}
                setShowAppointmentPanel={setShowAppointmentPanel}
              />
            )}

            {currentView === "day" && (
              <div className="day-view_CalendarView">
                <div className="day-view-header_CalendarView">
                  {currentDate.toDateString()}
                </div>

                <div className="day-scrollable-container">
                  <div className="day-time-column">
                    {timeSlots.map((slot, index) => (
                      <div
                        key={index}
                        className="day-view-time_CalendarView"
                        style={{ height: `${rowHeight}px` }}
                      // onClick={() => {
                      //   console.log("Time slot clicked:", slot);
                      //   setSelectedSlot({ date: currentDate, slot });
                      //   setShowAppointmentPanel(true);
                      // }}
                      >
                        {slot.display}
                      </div>
                    ))}
                  </div>

                  <div className="day-content-container">
                    <div className="day-view-rows_CalendarView">
                      {timeSlots.map((slot, index) => {
                        const filteredAppointments = appointments.filter(
                          (app) => {
                            const appDate = new Date(app.date);
                            const viewDate = new Date(currentDate);

                            const isSameDate =
                              appDate.getFullYear() ===
                              viewDate.getFullYear() &&
                              appDate.getMonth() === viewDate.getMonth() &&
                              appDate.getDate() === viewDate.getDate();

                            const [appHour, appMinute] = (
                              app.startTime || "00:00"
                            )
                              .split(":")
                              .map(Number);
                            const appStartMinutes =
                              appHour * 60 + (appMinute || 0);

                            return (
                              isSameDate &&
                              appStartMinutes >= slot.value &&
                              appStartMinutes < slot.value + timeInterval
                            );
                          }
                        );

                        return (
                          <div
                            key={index}
                            className="day-view-row_CalendarView"
                            style={{ height: `${rowHeight}px` }}
                            onClick={() => {
                              const hour = Math.floor(slot.value / 60);
                              const minute = slot.value % 60;

                              setSelectedSlot({
                                date: currentDate,
                                slot: {
                                  ...slot,
                                  hour,
                                  minute,
                                },
                                startTime: `${String(hour).padStart(
                                  2,
                                  "0"
                                )}:${String(minute).padStart(2, "0")}`,
                              });
                              setShowAppointmentPanel(true);
                            }}
                          >
                            {filteredAppointments.map((app, i) => (
                              <div
                                key={i}
                                className="appointment-block"
                                onClick={() => setActiveAppointment(app)}
                              >
                                <div className="appointment-label">
                                  Client: {app?.patientRequestId?.firstName}{" "}
                                  {app?.patientRequestId?.lastName}
                                  <br />
                                  Provider: {
                                    app?.doctorRequestId?.firstName
                                  }{" "}
                                  {app?.doctorRequestId?.lastName}
                                  <br />
                                  <button className="ClockIn_Button">
                                    Clock In
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {currentView === "month" && (
              <MonthView
                calendarDays={calendarDays}
                appointments={appointments}
                currentDate={currentDate}
                setSelectedSlot={setSelectedSlot}
                setShowAppointmentPanel={setShowAppointmentPanel}
              />
            )}

            {currentView === "agenda" && (
              <AgendaView
                currentView={currentView}
                currentAgendaTab={currentAgendaTab}
                setCurrentAgendaTab={setCurrentAgendaTab}
                appointments={
                  Array.isArray(filteredAppointments) &&
                    filteredAppointments.length > 0
                    ? filteredAppointments
                    : appointments
                }
                miniSelectedDate={miniSelectedDate}
              />
            )}
          </div>
        </div>
      </div>

      <div
        className={`appointment-panel_CalendarView ${showAppointmentPanel ? "show" : ""
          }`}
      >
        <div className="modal-content_CalendarView">
          <span
            className="close_CalendarView"
            onClick={() => setShowAppointmentPanel(false)}
          >
            &times;
          </span>
          <h2 id="modal-title">
            {editingAppointmentId ? "Edit Appointment" : "Add Appointment"}
          </h2>
          <form
            className="form-container_CalendarView"
            onSubmit={handleSubmit(onSubmit)}
          >
            {/* Client Information Section */}
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Client Information
              </div>
              <div>
                <div className="form-group_CalendarView">
                  <label htmlFor="client-select">Select Client:</label>
                  <select id="client-select" {...register("patientId")}>
                    <option value="">-- Select Client --</option>
                    {clientdata.map((client) => (
                      <option key={client._id} value={client._id}>
                        {client.firstName} {client.lastName}
                      </option>
                    ))}
                  </select>
                  {errors.patientId && (
                    <p className="error">{errors.patientId.message}</p>
                  )}
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="client-dob">DOB:</label>
                  <input
                    type="text"
                    id="client-dob"
                    disabled
                    {...register("dob")}
                    value={watch("dob")}
                  />
                </div>
              </div>
            </div>
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Provider Information
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="providerSelect">Select Provider:</label>
                  <select
                    id="providerSelect"
                    {...register("doctorId")}
                    onChange={(e) => getAvailableDetails(e.target.value)}
                  >
                    <option value="">-- Select --</option>
                    {providerdata.map((provider, index) => (
                      <option key={provider._id} value={provider._id}>
                        {provider.firstName} {provider.lastName}
                      </option>
                    ))}
                  </select>
                  {errors.doctorId && (
                    <p className="error">{errors.doctorId.message}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Appointment Details
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="appointment-type">Appointment Type:</label>
                  <select
                    id="appointment-type"
                    name="type"
                    // required
                    {...register("deliveryMode")}
                  >
                    <option value="">-- Select --</option>
                    {appointmentType.map((item, index) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {errors.deliveryMode && (
                    <p className="error">{errors.deliveryMode.message}</p>
                  )}
                </div>
                {selectedType === "Telehealth" && (
                  <div className="form-group_CalendarView">
                    <label>Telehealth URL:</label>
                    <a style={{ textAlign: "left" }}>Join Telehealth Session</a>
                  </div>
                )}
              </div>
              <CalendarComponent provideravailabledays={provideravailbledays} />
              <div>
                <div className="form-group_CalendarView">
                  <label htmlFor="date">Date:</label>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    // required
                    {...register("date")}
                  />
                  {errors.date && (
                    <p className="error">{errors.date.message}</p>
                  )}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="form-group_CalendarView">
                    <label htmlFor="time">
                      Start Time (Provider Time Zone - {providerAbbr || "..."}):
                    </label>

                    <TimeSelect
                      register={register}
                      name={"startTime"}
                      interval={parseInt(preDef.calendar_increment)}
                      format12Hour={true}
                    />

                    {/* <input
                      type="time"
                      id="time"
                      name="start"
                      step={'3000'}
                      {...register("startTime")}
                    /> */}
                    {errors.startTime && (
                      <p className="error">{errors.startTime.message}</p>
                    )}
                  </div>
                  <div style={{ width: 30 }} />
                  <div className="form-group_CalendarView">
                    <label htmlFor="time">
                      {" "}
                      Client Time ({clientAbbr || "..."}):
                    </label>
                    <input
                      type="text"
                      id="clientTime"
                      value={clientTime}
                      disabled
                    />
                  </div>
                </div>
              </div>
              {startTime && selectedappointmentDate && (
                <div>
                  This appointment will display as{" "}
                  <strong>{providerTime}</strong> for the provider and{" "}
                  <strong>{clientTime}</strong> for the client.
                </div>
              )}
              <div>
                <div className="form-group_CalendarView">
                  <label htmlFor="visit-reason">Resource:</label>
                  <select
                    id="visit-reason"
                    name="appointmentResource"
                    {...register("appointmentResource")}
                  >
                    <option value="">-- Select Resource --</option>
                    {resourcedata.map((item) => {
                      return (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                  {errors.appointmentResource && (
                    <p className="error">
                      {errors.appointmentResource.message}
                    </p>
                  )}
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="visit-reason">Visit Reason:</label>
                  <select
                    id="visit-reason"
                    name="visitReason"
                    {...register("visitReason")}
                  >
                    <option value="">-- Select Visit Reason --</option>
                    {visitReasondata.map((item) => {
                      return (
                        <option key={item._id} value={item._id}>
                          {item.visitReason}
                        </option>
                      );
                    })}
                  </select>
                  {errors.visitReason && (
                    <p className="error">{errors.visitReason.message}</p>
                  )}
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="duration">Duration (in mins):</label>
                  <input
                    type="number"
                    id="duration"
                    name="duration"
                    {...register("duration")}
                    min={1}
                  // required
                  />
                  {errors.duration && (
                    <p className="error">{errors.duration.message}</p>
                  )}
                </div>
              </div>
              {/* New Status Field */}
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="appointment-status">Status:</label>
                  <select
                    id="appointment-status"
                    name="appointmentStatus"
                    // required
                    {...register("appointmentStatus")}
                  >
                    <option value="">-- Select Visit Status --</option>
                    {visitstatus.map((item) => {
                      return (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                  {errors.appointmentStatus && (
                    <p className="error">{errors.appointmentStatus.message}</p>
                  )}
                </div>
              </div>
            </div>
            {/* Repeat Appointment Section */}
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Repeat Appointment
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="repeats">Repeats:</label>
                  <input
                    type="checkbox"
                    id="repeats"
                    name="repeats"
                    {...register("repeats")}
                  // defaultValue={'No'}
                  />
                </div>
              </div>
              {repeats && (
                <div id="repeat-options">
                  <div className="form-row_CalendarView">
                    <label>Repeat Days:</label>
                    <div className="repeat-days-container_CalendarView">
                      {["sun", "mon", "tue", "wed", "thu", "fri", "sat"].map(
                        (day) => (
                          <label className="day-pill_CalendarView" key={day}>
                            <input
                              type="checkbox"
                              {...register("repeatDays")}
                              value={day}
                            />
                            <span>{day.charAt(0).toUpperCase()}</span>
                          </label>
                        )
                      )}
                    </div>
                    {errors.repeatDays && (
                      <p className="error">{errors.repeatDays.message}</p>
                    )}
                  </div>
                  <div className="form-row_CalendarView">
                    <label>End Condition:</label>
                    <div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="radio"
                          value="end-of-month"
                          {...register("endCondition")}
                          defaultChecked
                          style={{ height: 15, width: 15, marginRight: 20 }}
                        />{" "}
                        <label style={{ marginTop: -1 }}>
                          Until the End of Month
                        </label>
                      </div>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="radio"
                          name="end-condition"
                          value="specific-date"
                          {...register("endCondition")}
                          style={{ height: 15, width: 15, marginRight: 20 }}
                        />{" "}
                        <label style={{ marginTop: -1 }}>Specific Date</label>
                        <input
                          type="date"
                          id="specific-date"
                          {...register("specificDate")}
                          style={{ width: 200, marginLeft: 10 }}
                        />
                      </div>
                      {errors.specificDate && (
                        <p className="error">{errors.specificDate.message}</p>
                      )}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="radio"
                          {...register("endCondition")}
                          value="number-of-events"
                          style={{ height: 15, width: 15, marginRight: 20 }}
                        />{" "}
                        <label>Number of Events</label>
                        <input
                          type="number"
                          id="number-of-events"
                          {...register("numberOfEvents", {
                            valueAsNumber: true,
                          })}
                          placeholder="Enter number of events"
                          style={{ width: 200, marginLeft: 10 }}
                        />
                      </div>
                      {errors.numberOfEvents && (
                        <p className="error">{errors.numberOfEvents.message}</p>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Service Location Section */}
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Service Details
              </div>
              <div>
                <div className="form-group_CalendarView">
                  <label htmlFor="location">Service Location:</label>

                  <select
                    id="location"
                    name="location"
                    {...register("serviceLocationId")}
                  // required
                  >
                    <option value="">-- Select Service Location --</option>
                    {addressData.map((item) => {
                      return (
                        <option key={item._id} value={item?._id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                  {errors.serviceLocationId && (
                    <p className="error">{errors.serviceLocationId.message}</p>
                  )}
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="payment">Payment Source:</label>
                  <input
                    type="text"
                    name="payment"
                    // disabled

                    value={watch("paymentSource")}
                    {...register("paymentSource")}
                  />
                  {errors.paymentSource && (
                    <p className="error">{errors.paymentSource.message}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Patient Intake
              </div>

              <DropDownManuCustomMulti
                label="Required Documents:"
                placeholder="Select option"
                options={[
                  { _id: "Medical History", name: "Medical History" },
                  { _id: "Consent Forms", name: "Consent Forms" },
                  {
                    _id: "Basic Information",
                    name: "Basic Information",
                  },
                  { _id: "Billing Profile", name: "Billing Profile" },
                  { _id: "Identification", name: "Identification" },
                  {
                    _id: "Emergency Contacts",
                    name: "Emergency Contacts",
                  },
                  {
                    _id: "Allergies & Medications",
                    name: "Allergies & Medications",
                  },
                  { _id: "Measures & Vitals", name: "Measures & Vitals" },
                  {
                    _id: "Document Upload",
                    name: "Document Upload",
                  },
                ]}
                name="RequiredDocuments"
                id="_id"
                clearErrors={clearErrors}
                onSelect={HandleselectpatientIntake}
                register={register}
              />
              {errors.patientIntake && (
                <p className="error">{errors.patientIntake.message}</p>
              )}
            </div>
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Provider Task
              </div>

              <DropDownManuCustomMulti
                label="Tasks:"
                placeholder="Select option"
                options={[
                  {
                    _id: "Review Patient History",
                    name: "Review Patient History",
                  },
                  { _id: "Call Patient", name: "Call Patient" },
                  {
                    _id: "Update Records",
                    name: "Update Records",
                  },
                  { _id: "Consult with Team", name: "Consult with Team" },
                ]}
                name="Tasks"
                id="_id"
                clearErrors={clearErrors}
                onSelect={Handleselecttask}
                register={register}
              />
              {errors.providerTask && (
                <p className="error">{errors.providerTask.message}</p>
              )}
            </div>
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Patient Confirmation Methods
              </div>
              <div className="form-row_CalendarView">
                <label>
                  <input type="checkbox" {...register("email-confirm")} />{" "}
                  {"  "}
                  Send confirmation Email to{" "}
                  {selectedClientId &&
                    (isEditingClientEmail ? (
                      <>
                        <input
                          type="text"
                          value={clientEmail}
                          onChange={(e) => setClientEmail(e.target.value)}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            if (!validateEmail(clientEmail)) {
                              setClientEmailError("Invalid email address");
                              return;
                            }
                            setClientEmailError("");
                            setIsEditingClientEmail(false);
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ color: "black" }}
                          />
                        </button>
                        {clientEmailError && (
                          <p className="error">{clientEmailError}</p>
                        )}
                      </>
                    ) : (
                      <>
                        {clientEmail}
                        <button
                          type="button"
                          onClick={() => setIsEditingClientEmail(true)}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "black", marginLeft: 10 }}
                          />
                        </button>
                      </>
                    ))}
                </label>
                <label>
                  <input type="checkbox" {...register("sms-confirm")} /> {"  "}
                  Send confirmation SMS to{" "}
                  {selectedClientId &&
                    (isEditingClientPhone ? (
                      <>
                        <input
                          type="text"
                          value={clientPhone}
                          onChange={(e) => setClientPhone(e.target.value)}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            if (!validatePhone(clientPhone)) {
                              setClientPhoneError(
                                "Phone number must be 10 digits"
                              );
                              return;
                            }
                            setClientPhoneError("");
                            setIsEditingClientPhone(false);
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ color: "black" }}
                          />
                        </button>
                        {clientPhoneError && (
                          <p className="error">{clientPhoneError}</p>
                        )}
                      </>
                    ) : (
                      <>
                        {clientPhone}
                        <button
                          type="button"
                          onClick={() => setIsEditingClientPhone(true)}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "black", marginLeft: 10 }}
                          />
                        </button>
                      </>
                    ))}
                </label>
                <label>
                  <input
                    type="checkbox"
                    id="inapp-confirm"
                    name="inapp-confirm"
                    {...register("inapp-confirm")}
                  />
                  {"  "}
                  Send push notification to the app
                </label>
              </div>
            </div>

            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Provider Confirmation Methods
              </div>
              <div className="form-row_CalendarView">
                <label>
                  <input
                    type="checkbox"
                    {...register("provider-email-confirm")}
                  />{" "}
                  {"  "}
                  Send confirmation Email to
                  {watch("doctorId") &&
                    (isEditingProviderEmail ? (
                      <>
                        <input
                          type="text"
                          value={providerEmail}
                          onChange={(e) => setProviderEmail(e.target.value)}
                        />
                        {providerEmailError && (
                          <p className="error">{providerEmailError}</p>
                        )}
                        <button
                          type="button"
                          onClick={() => {
                            if (!validateEmail(providerEmail)) {
                              setProviderEmailError("Invalid email address");
                              return;
                            }
                            setProviderEmailError("");
                            setIsEditingProviderEmail(false);
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ color: "black" }}
                          />
                        </button>
                      </>
                    ) : (
                      <>
                        {providerEmail}
                        <button
                          type="button"
                          onClick={() => setIsEditingProviderEmail(true)}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "black", marginLeft: 10 }}
                          />
                        </button>
                      </>
                    ))}
                </label>
                <label>
                  <input
                    type="checkbox"
                    {...register("provider-sms-confirm")}
                  />{" "}
                  {"  "}
                  Send confirmation SMS to
                  {watch("doctorId") &&
                    (isEditingProviderPhone ? (
                      <>
                        <input
                          type="text"
                          value={providerPhone}
                          onChange={(e) => setProviderPhone(e.target.value)}
                        />
                        {providerPhoneError && (
                          <p className="error">{providerPhoneError}</p>
                        )}
                        <button
                          type="button"
                          onClick={() => {
                            if (!validatePhone(providerPhone)) {
                              setProviderPhoneError(
                                "Phone number must be 10 digits"
                              );
                              return;
                            }
                            setProviderPhoneError("");
                            setIsEditingProviderPhone(false);
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ color: "black" }}
                          />
                        </button>
                      </>
                    ) : (
                      <>
                        {providerPhone}
                        <button
                          type="button"
                          onClick={() => setIsEditingProviderPhone(true)}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "black", marginLeft: 10 }}
                          />
                        </button>
                      </>
                    ))}
                </label>
                <label>
                  <input
                    type="checkbox"
                    id="provider-inapp-confirm"
                    name="provider-inapp-confirm"
                    {...register("provider-inapp-confirm")}
                  />
                  {"  "}
                  Send push notification to provider app
                </label>
              </div>
            </div>

            <div className="button-container_CalendarView">
              <button type="submit" className="confirm-btn_CalendarView">
                Confirm Appointment
              </button>
              <button
                type="button"
                className="decline-btn_CalendarView"
                onClick={() => setShowAppointmentPanel(false)}
              >
                Decline Appointment
              </button>
            </div>
          </form>
        </div>
      </div>

      {showSyncModal && (
        <div id="synch-modal" className="modal_CalendarView">
          <div className="modal-content_CalendarView">
            <span
              className="close_CalendarView"
              onClick={() => setShowSyncModal(false)}
            >
              ×
            </span>
            <h2>Calendar Synchronization</h2>
            <p style={{ textAlign: "left" }}>
              Select your calendar service to synchronize:
            </p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
              <button id="sync-google" className="synch-button_CalendarView">
                Google Calendar
              </button>
              <button id="sync-outlook" className="synch-button_CalendarView">
                Outlook
              </button>
              <button id="sync-ical" className="synch-button_CalendarView">
                iCalendar
              </button>
            </div>
          </div>
        </div>
      )}
      {showSettingsModal && (
        <div id="settings-modal" className="modal_CalendarView">
          <div className="modal-content_CalendarView">
            <div className="close_CalendarView">
              <span
                style={{ width: 30 }}
                onClick={() => setShowSettingsModal(false)}
              >
                &times;
              </span>
            </div>
            <h2>Working Hours Settings</h2>
            <p>
              Configure your working hours, locations, and scheduling
              constraints.
            </p>
            <div id="settings-days-container" style={{ marginBottom: 20 }}>
              {Object.keys(weeklySchedule).map((day) => (
                <div key={day} className="day-row_CalendarView">
                  <div className="day-row-header_CalendarView">
                    <strong>{day}</strong>
                    <button
                      type="button"
                      className="add-block-btn_CalendarView"
                      onClick={() => addTimeBlock(day)}
                    >
                      Add Time Block
                    </button>
                  </div>
                  <div className="time-blocks_CalendarView">
                    {weeklySchedule[day].map((block, index) => (
                      <div key={index} className="time-block_CalendarView">
                        <label>Start:</label>
                        <input
                          type="time"
                          value={block.start}
                          onChange={(e) =>
                            handleTimeBlockChange(
                              day,
                              index,
                              "start",
                              e.target.value
                            )
                          }
                        />
                        <label>End:</label>
                        <input
                          type="time"
                          value={block.end}
                          onChange={(e) =>
                            handleTimeBlockChange(
                              day,
                              index,
                              "end",
                              e.target.value
                            )
                          }
                        />
                        <label>Location:</label>
                        <select
                          value={block.location}
                          onChange={(e) =>
                            handleTimeBlockChange(
                              day,
                              index,
                              "location",
                              e.target.value
                            )
                          }
                        >
                          <option value="">-- Select --</option>
                          {servicelocation.map((item) => {
                            return (
                              <option key={item._id} value={item?._id}>
                                {item?.name}
                              </option>
                            );
                          })}
                        </select>
                        <button
                          type="button"
                          className="remove-block-btn_CalendarView"
                          onClick={() => removeTimeBlock(day, index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              <div className="section_CalendarView" id="constraints-section">
                <div
                  className="section-header_CalendarView"
                  style={{ textAlign: "left" }}
                >
                  Scheduling Constraints
                </div>

                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="min-gap">
                      Minimum Gap Between Sessions (minutes):
                    </label>
                    <input
                      onChange={(e) =>
                        setPreDef({ ...preDef, min_gap: e.target.value })
                      }
                      type="number"
                      id="min_gap"
                      name="min_gap"
                      min={0}
                      value={preDef?.min_gap}
                      defaultValue={15}
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="max-appointments">
                      Maximum Appointments Per Day:
                    </label>
                    <input
                      onChange={(e) =>
                        setPreDef({
                          ...preDef,
                          max_appointments: e.target.value,
                        })
                      }
                      type="number"
                      id="max_appointments"
                      name="max_appointments"
                      min={1}
                      value={preDef?.max_appointments}
                      defaultValue={8}
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="max-weekly-appointments">
                      Maximum Appointments Per Week:
                    </label>
                    <input
                      onChange={(e) =>
                        setPreDef({
                          ...preDef,
                          max_weekly_appointments: e.target.value,
                        })
                      }
                      type="number"
                      id="max_weekly_appointments"
                      name="max_weekly_appointments"
                      value={preDef?.max_weekly_appointments}
                      min={1}
                      defaultValue={preDef?.max_weekly_appointments}
                    />
                  </div>
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="booking-leadtime">
                      Client Booking Lead Time (Hours):
                    </label>
                    <input
                      onChange={(e) =>
                        setPreDef({
                          ...preDef,
                          booking_leadtime: e.target.value,
                        })
                      }
                      type="number"
                      id="booking_leadtime"
                      name="booking_leadtime"
                      min={1}
                      value={preDef?.booking_leadtime}
                      defaultValue={24}
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="cancellation-leadtime">
                      Cancellation Lead Time (Hours):
                    </label>
                    <input
                      onChange={(e) =>
                        setPreDef({
                          ...preDef,
                          cancellation_leadtime: e.target.value,
                        })
                      }
                      type="number"
                      id="cancellation_leadtime"
                      name="cancellation_leadtime"
                      value={preDef?.cancellation_leadtime}
                      min={1}
                      defaultValue={24}
                    />
                  </div>
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="break-start">
                      Mandatory Break (Start):
                    </label>
                    <input
                      onChange={(e) =>
                        setPreDef({ ...preDef, break_start: e.target.value })
                      }
                      type="time"
                      id="break_start"
                      name="break_start"
                      value={preDef?.break_start}
                      defaultValue="12:00"
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="break-end">Mandatory Break (End):</label>
                    <input
                      onChange={(e) =>
                        setPreDef({ ...preDef, break_end: e.target.value })
                      }
                      type="time"
                      id="break_end"
                      name="break_end"
                      value={preDef?.break_end}
                      defaultValue="13:00"
                    />
                  </div>
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="min-appt-duration">
                      Minimum Appointment Duration (Minutes):
                    </label>
                    <input
                      onChange={(e) =>
                        setPreDef({
                          ...preDef,
                          min_appt_duration: e.target.value,
                        })
                      }
                      type="number"
                      id="min_appt_duration"
                      name="min_appt_duration"
                      value={preDef?.min_appt_duration}
                      min={1}
                      defaultValue={15}
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="max-appt-duration">
                      Maximum Appointment Duration (Minutes):
                    </label>
                    <input
                      onChange={(e) =>
                        setPreDef({
                          ...preDef,
                          max_appt_duration: e.target.value,
                        })
                      }
                      type="number"
                      id="max_appt_duration"
                      name="max_appt_duration"
                      value={preDef?.max_appt_duration}
                      min={1}
                      defaultValue={60}
                    />
                  </div>
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="buffer-before">
                      Buffer Time Before (Minutes):
                    </label>
                    <input
                      onChange={(e) =>
                        setPreDef({ ...preDef, buffer_before: e.target.value })
                      }
                      type="number"
                      id="buffer_before"
                      name="buffer_before"
                      min={0}
                      value={preDef?.buffer_before}
                      defaultValue={5}
                    />
                  </div>
                  <div className="form-group_CalendarView">
                    <label htmlFor="buffer-after">
                      Buffer Time After (Minutes):
                    </label>
                    <input
                      onChange={(e) =>
                        setPreDef({ ...preDef, buffer_after: e.target.value })
                      }
                      type="number"
                      id="buffer_after"
                      name="buffer_after"
                      min={0}
                      value={preDef?.buffer_after}
                      defaultValue={5}
                    />
                  </div>
                </div>
                <div className="form-row_CalendarView">
                  <div className="form-group_CalendarView">
                    <label htmlFor="calendar-increment">
                      Calendar Increment (minutes):
                    </label>
                    <select
                      id="calendar-increment"
                      name="calendar_increment"
                      value={preDef.calendar_increment}
                      onChange={(e) =>
                        setPreDef({
                          ...preDef,
                          calendar_increment: e.target.value,
                        })
                      }
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                      <option value={60}>60</option>
                    </select>
                  </div>
                </div>
                <p className="small_CalendarView">
                  <em>
                    For advanced constraints (equipment/room availability,
                    multi-provider overlaps, time zone rules, etc.), configure
                    in admin console or add here.
                  </em>
                </p>
              </div>
            </div>

            <div className="button-container_CalendarView">
              <button
                type="button"
                className="save-settings-button_CalendarView"
                onClick={handleSaveSettings}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {activeAppointment && (
        <div
          className="modal-overlay_week"
          onClick={() => setActiveAppointment(null)}
        >
          <div
            className="modal-content_week"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="tooltip-card">
              <div className="tooltip-header">
                <div className="tooltip-time">
                  {(() => {
                    if (
                      !activeAppointment.startTime ||
                      !activeAppointment.Duration
                    ) {
                      return activeAppointment.startTime || "N/A";
                    }

                    const start = moment(activeAppointment.startTime, "HH:mm");
                    const durationMinutes = parseInt(
                      activeAppointment.Duration
                    );
                    const end = start.clone().add(durationMinutes, "minutes");

                    return `${start.format("HH:mm")} - ${end.format("HH:mm")}`;
                  })()}
                </div>
                <div
                  className="tooltip-status"
                  style={{
                    backgroundColor:
                      activeAppointment?.appointmentStatus?.color,
                  }}
                >
                  {activeAppointment?.appointmentStatus?.name}
                </div>
              </div>

              <div className="tooltip-patient" style={{ textAlign: "left" }}>
                <strong>
                  {activeAppointment.patientRequestId?.firstName}{" "}
                  {activeAppointment.patientRequestId?.lastName}
                </strong>
                <div>DOB: {activeAppointment.dob || "N/A"}</div>
              </div>

              <hr />

              <div className="tooltip-section" style={{ textAlign: "left" }}>
                <h4>Visit Information</h4>
                <div>
                  <strong>Provider:</strong> Dr.{" "}
                  {activeAppointment.doctorRequestId?.firstName}{" "}
                  {activeAppointment.doctorRequestId?.lastName}
                </div>
                <div>
                  <strong>Appointment Type:</strong>{" "}
                  {activeAppointment.deliveryMode?.name || "N/A"}
                </div>
                <div>
                  <strong>Location:</strong>{" "}
                  {activeAppointment.serviceLocationId?.name || "N/A"}
                </div>
                <div>
                  <strong>Visit Reason:</strong>{" "}
                  {activeAppointment.visitReason?.visitReason || "N/A"}
                </div>
                <div>
                  <strong>Service Code(s):</strong>{" "}
                  {activeAppointment.visitReason?.cptCode || "N/A"}
                </div>
                <div className="patient-intake">
                  <strong>Patient Intake:</strong>
                  <span> Pending </span>
                  <button style={{ color: "black" }}>Resend</button>
                </div>
                <div>
                  <strong>Balance:</strong> $0.00
                </div>
              </div>

              <div className="tooltip-section" style={{ textAlign: "left" }}>
                <h4>Financial Information</h4>
                <div>
                  <strong>Plan:</strong> BCBS FL HMO
                </div>
                <div>
                  <strong>Effective:</strong> Not Specified
                </div>
                <div>
                  <strong>Copay:</strong> $0.00
                </div>
                <div>
                  <strong>Eligibility:</strong> Eligible for visit on 3/07/2025
                  <div className="tooltip-actions">
                    <a href="#">View Report</a>
                    <a href="#">Check Again</a>
                  </div>
                </div>
              </div>

              <div className="tooltip-footer">
                <button style={{ color: "black" }}> Status</button>
                <button style={{ color: "black" }}>Create Note</button>
                <button style={{ color: "black" }}>Actions</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProviderCalendarView;
